import type { PageType } from '@/types/agent';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { notification, Spin } from 'antd';
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/callback/$method')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    const { hash } = window.location;
    if (hash && !called.current) {
      called.current = true;
      const urlParams = new URLSearchParams(hash.split('#')[1]);
      const stateString = urlParams.get('state');
      const accessToken = urlParams.get('access_token');
      if (stateString && accessToken) {
        const payload = JSON.parse(decodeURIComponent(stateString));

        void navigate({
          to: '/compagnies/$id/products/$productId',
          params: { id: payload.id, productId: payload.productId },
          hash: hash,
          search: {
            agentId: payload.agentId,
            pageType: payload.pageType as PageType,
            access_token: accessToken,
            state: stateString,
          },
        });
        return;
      }
      notification.error({
        key: 'error-login',
        message: 'Erreur lors de la connexion',
      });
      // void navigate({
      //   to: '/companies',
      // });
    }
  }, [called]);

  return (
    <div className="h-screen flex items-center justify-center">
      <Spin size="large" />
    </div>
  );
}
